import React, { useState } from "react";
import axios from 'axios';
import { URL_API_SIA } from "../../Contantes/Constantes";
import Modal from '@mui/material/Modal';
import CircularProgress from '@mui/material/CircularProgress';
import { ContenedorConfirmacion } from "../../Componentes/ModalConfirmacion";
import { useBody } from "../../Body/state/BodyContext";
import { setupInterceptorsTo } from "../../Componentes/API/AxiosBuilder";
import { useAreas } from "../State/AreasContext";

export const BorrarAreaModal = ({ open, onClose, area, handleUpdate, ...props }) => {
    const { getAreas } = useAreas();
    const { setMessage, setSuccess } = useBody();
    const axiosInstance = setupInterceptorsTo(axios.create());
    const [loading, setLoading] = useState(false);

    const peticionDelete = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance({
                method: 'DELETE',
                url: `${URL_API_SIA}/areas/area/borrar/${area.id}`,
            });
            setSuccess("Área y Sub áreas borradas exitosamente");
        } catch (error) {
            const response = error.response;
            if (response.status === 409) {
                setMessage(response.data.status);
            } else {
                setMessage("Hubo un error al intentar borrar el área y las subáreas (Código de error: 000035)");
            }
        } finally {
            setLoading(false);
            onClose();
            handleUpdate();
        }
    };

    const mensajePrimario = <b>¿Estás seguro de querer eliminar el área {area.name} y sus subáreas?</b>;
    const mensajeSecundario = <p>Al presionar <i>Sí, eliminar</i>, <b>El área y las subáreas serán eliminadas y esta acción no puede revertirse.</b></p>;

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            {loading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                    <CircularProgress />
                </div>
            ) : (
                <ContenedorConfirmacion
                    mensajePrimario={mensajePrimario}
                    mensajeSecundario={mensajeSecundario}
                    accion={() => peticionDelete()}
                    mensajeAceptar={"Sí, eliminar"}
                    handleClose={onClose}
                    colorAceptar="red"
                />
            )}
        </Modal>
    );
};
